// src/slices/userProfile/reducer.ts
// Redux slice for User Profile

import { createSlice } from '@reduxjs/toolkit';
import {
  fetchUserProfile,
  updateProfile,
  uploadProfileAvatar,
} from './thunk';

interface UserProfileState {
  profile: any;
  loading: boolean;
  error: string | null;
  uploadingAvatar: boolean;
}

const initialState: UserProfileState = {
  profile: null,
  loading: false,
  error: null,
  uploadingAvatar: false,
};

const userProfileSlice = createSlice({
  name: 'userProfile',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // Fetch user profile
    builder
      .addCase(fetchUserProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.profile = action.payload;
      })
      .addCase(fetchUserProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });

    // Update profile
    builder
      .addCase(updateProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.profile = action.payload;
      })
      .addCase(updateProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });

    // Upload avatar
    builder
      .addCase(uploadProfileAvatar.pending, (state) => {
        state.uploadingAvatar = true;
        state.error = null;
      })
      .addCase(uploadProfileAvatar.fulfilled, (state, action) => {
        state.uploadingAvatar = false;
        if (state.profile) {
          state.profile.avatar = action.payload;
        }
      })
      .addCase(uploadProfileAvatar.rejected, (state, action) => {
        state.uploadingAvatar = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearError } = userProfileSlice.actions;
export default userProfileSlice.reducer;